import { cx } from '@linaria/core';
import { SupportIcon } from '@ui/kit/icons';
import { configRefs } from '@utils/constants';
import { heading, header } from '../../shared.header.style.js';
import { spacer, supportCls, supportIconCls, header as header$1 } from './atom.header.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const StatusHeader = () => {
  return /*#__PURE__*/jsxs("header", {
    className: cx(header, header$1),
    children: [/*#__PURE__*/jsx("div", {
      className: spacer
    }), /*#__PURE__*/jsx("h1", {
      className: heading,
      children: "Teknisk support"
    }), /*#__PURE__*/jsxs("a", {
      className: supportCls,
      href: `${configRefs.urls.gu.dangerouslyAssertSyncValue()}/kundeservice/teknisk-support`,
      target: "_blank",
      rel: "noreferrer",
      children: [/*#__PURE__*/jsx("span", {
        className: supportIconCls,
        children: /*#__PURE__*/jsx(SupportIcon, {})
      }), "Skriv til support"]
    })]
  });
};

export { StatusHeader };
//# sourceMappingURL=atom.header.js.map
